import script from "./Scene.vue?vue&type=script&setup=true&lang=js"
export * from "./Scene.vue?vue&type=script&setup=true&lang=js"

import "./Scene.vue?vue&type=style&index=0&id=1b4b5e42&lang=less&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b4b5e42"]])

export default __exports__